<template>
  <div v-if="show" class="modal-overlay" @click="onCancel">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h2 class="modal-title">{{ $t('deleteCategory') }}</h2>
      </div>

      <div class="modal-body">
        <div class="confirmation-message">
          <p class="message-text">
            {{ $t('sureDeleteCategory') }}<strong>{{ categoryName }}</strong> ?
          </p>
          <p class="warning-text">
            {{ $t('thisActionCannotBeUndone') }}
          </p>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn-cancel" @click="onCancel">
          {{ $t('cancelButton') }}
        </button>
        <button class="btn-delete" @click="onConfirm">
          {{ $t('deleteButton') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'confirm-delete-category',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    categoryName: {
      type: String,
      default: ''
    }
  },
  methods: {
    onConfirm () {
      this.$emit('confirm')
    },
    onCancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/sass/variables";

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 400px;
  width: 90%;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f5f5f5;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: $black;
}

.modal-body {
  padding: 25px;
}

.confirmation-message {
  text-align: center;
}

.message-text {
  font-size: 1rem;
  color: $black;
  margin-bottom: 10px;
  line-height: 1.5;

  strong {
    font-weight: 600;
    color: #d32f2f;
  }
}

.warning-text {
  font-size: 0.85rem;
  color: #666;
  font-style: italic;
  margin: 0;
}

.modal-footer {
  display: flex;
  gap: 10px;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid #e0e0e0;
  background-color: #f5f5f5;
}

.btn-cancel,
.btn-delete {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  min-width: 120px;
}

.btn-cancel {
  background-color: #e0e0e0;
  color: $black;

  &:hover {
    background-color: #d0d0d0;
  }
}

.btn-delete {
  background-color: #f44336;
  color: white;

  &:hover {
    background-color: #da190b;
  }
}
</style>
